export default {
  title: "Log in",
  log_in_message: "I want to login",
  email: "Email",
  password: "Password",
  forgot_password: "I Forgot password",
  reset_password: "Reset password",
  reset_password_email: "Password reset email",
  resend_verification_email: "Re-send verification email",
  login_button: "Login",
  or_use_social: "Or sign in/up with",
  type_email: "Type your email",
  type_password: "Type your password",
  registration_title: "Register",
  registration_message: "I want to register",
  register_button: "Register",
  password_again: "Password again",
  cancel: "Cancel",
  stay_signed_in: "Stay singed in",
  registration_success_message: `Your account has been successfully created. A verification email has been sent to your email address.
  Please finalize the registration process by click the link in the verification email.`,

  api_messages: {
    email_not_verified: "You email was not yet verified, if you didnt receive a verification email, click here:"
  },

  messages: {
    successful_password_reset: "A password reset email has been successfully send to your email address.",
    email_verification_resend: `Verification email has been sent to your email address.
    Please finalize the project setup process by click the link in the verification email.`
  }
}
